import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=e71e71de&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=js&"
export * from "./advertisement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71e71de",
  null
  
)

export default component.exports